"use strict";

exports.__esModule = true;
exports.ArrowUpDownIcon = void 0;

var _icon = require("@chakra-ui/icon");

var ArrowUpDownIcon = (0, _icon.createIcon)({
  viewBox: "0 0 16 16",
  d: "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z",
  displayName: "ArrowUpDownIcon"
});
exports.ArrowUpDownIcon = ArrowUpDownIcon;
//# sourceMappingURL=ArrowUpDown.js.map